import { Button, Card, CircularProgress, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../../components';
import { getDetailDataAset, getTipeAset, updDataAset } from '../../../../redux/actions/AsetInvestasiActions';
import { getKota } from '../../../../redux/actions/KotaActions';
import { getProvinsi } from '../../../../redux/actions/ProvinsiActions';

const EditData = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const {tipe} = useSelector(({asetInvest}) => asetInvest)
    const { provinsi } = useSelector(
        ({ provinsi }) => provinsi
    );
    const { kota } = useSelector(
        ({ kota }) => kota
    );
    const [params, setParams] = useState({
        thumbnail_landscape: "",
        thumbnail_landscape_preview: "",
        thumbnail_landscape_ori: "",
        thumbnail_portrait: "",
        thumbnail_portrait_preview: "",
        thumbnail_portrait_ori: "",
        name: "",
        province_code: "",
        city_code: "",
        type_code: "",
        product_code: "",
        address: ""
    });
    useEffect(() => {
      dispatch(getTipeAset({paginate: false}))
      dispatch(getProvinsi({paginate: false}))
    }, [dispatch])
    const handleChange = ({ target: { value, name } }) => {
        if(name === "province_code") {
            setParams(pref => ({
                ...pref,
                city_code: ""
            }));
            dispatch(getKota({paginate: false, province_code: value}))
        }
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updDataAset(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const handleChangeFoto = (name, file) => {
        setParams((pref) => ({
            ...pref,
            [name]: file,
            [name+'_preview']: file
        }));
    };
    const getData = useCallback(() => {
        setLoading(true);
        getDetailDataAset(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    dispatch(getKota({paginate: false, province_code: data?.province_code}))
                    setParams((pref) => ({
                        ...pref,
                        thumbnail_landscape: "",
                        thumbnail_landscape_preview: data?.thumbnail_landscape,
                        thumbnail_landscape_ori: data?.thumbnail_landscape_ori,
                        thumbnail_portrait: "",
                        thumbnail_portrait_preview: data?.thumbnail_portrait,
                        thumbnail_portrait_ori: data?.thumbnail_portrait_ori,
                        name: data?.name,
                        province_code: data?.province_code,
                        city_code: data?.city_code,
                        type_code: data?.type_code,
                        product_code: data?.product_code,
                        address: data?.address
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert, dispatch]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            product_code: id
        }));
        getData();
    }, [getData, id]);
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Data</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <UploadImage
                                            uploadFoto={(file) => handleChangeFoto("thumbnail_landscape", file)}
                                            label="Unggah Foto Landscape"
                                            preview={
                                                params?.thumbnail_landscape_preview
                                            }
                                            required={true}
                                            noCrop
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 1440 x 617'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <UploadImage
                                            uploadFoto={(file) => handleChangeFoto("thumbnail_portrait", file)}
                                            label="Unggah Foto Potrait"
                                            preview={
                                                params?.thumbnail_portrait_preview
                                            }
                                            required={true}
                                            noCrop={true}
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 500 x 600'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel htmlFor="name" className="mb-4">
                                            Nama{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <TextValidator
                                            id="name"
                                            placeholder="Nama Properti"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="name"
                                            value={params.name || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Nama Properti terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel htmlFor="type_code" className="mb-4">
                                            Tipe{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <Select
                                            size="small"
                                            labelId="type_code"
                                            value={params.type_code}
                                            onChange={handleChange}
                                            variant="outlined"
                                            className="w-full"
                                            name="type_code"
                                            displayEmpty
                                        >
                                            <MenuItem value="" selected>
                                                Pilih Tipe
                                            </MenuItem>
                                            {tipe?.map((item) => (
                                                <MenuItem
                                                    value={item.type_code}
                                                    key={item.type_code}
                                                >
                                                    {item.type_id}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel htmlFor="province_code" className="mb-4">
                                            Provinsi{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <Select
                                            size="small"
                                            labelId="province_code"
                                            value={params.province_code}
                                            onChange={handleChange}
                                            variant="outlined"
                                            className="w-full"
                                            name="province_code"
                                            displayEmpty
                                        >
                                            <MenuItem value="" selected>
                                                Pilih Provinsi
                                            </MenuItem>
                                            {provinsi?.map((item) => (
                                                <MenuItem
                                                    value={item.province_code}
                                                    key={item.province_code}
                                                >
                                                    {item.province_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel htmlFor="city_code" className="mb-4">
                                            Kota{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <Select
                                            size="small"
                                            labelId="city_code"
                                            value={params.city_code}
                                            onChange={handleChange}
                                            variant="outlined"
                                            className="w-full"
                                            name="city_code"
                                            displayEmpty
                                        >
                                            <MenuItem value="" selected>
                                                Pilih Kota
                                            </MenuItem>
                                            {kota?.map((item) => (
                                                <MenuItem
                                                    value={item.city_code}
                                                    key={item.city_code}
                                                >
                                                    {item.city_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel
                                            htmlFor="address"
                                            className="mb-4"
                                        >
                                           Alamat
                                        <span className="text-danger">*</span>
                                        </InputLabel>
                                        <TextValidator
                                            id="address"
                                            placeholder="Alamat"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="address"
                                            value={params.address || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan alamat terlebih dahulu'
                                            ]}
                                            multiline
                                            maxRows={16}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default EditData;
